import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { TrendingDown, Shield, Zap, Clock, Users, Award, Cable } from 'lucide-react';
import { advantages } from './mock';

const iconMap = {
  TrendingDown,
  Shield,
  Zap,
  Clock,
  Users,
  Award,
  Cable
};

const Advantages = () => {
  return (
    <section id="advantages" className="py-20 bg-gray-100">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <Badge className="mb-4 bg-orange-100 text-orange-800 hover:bg-orange-100">
            Nossas Soluções
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Vantagens de Ter um
            <span className="block text-orange-600">Especialista ao Seu Lado</span>
          </h2>
          <p className="text-xl text-gray-600">
            Nossa experiência de mais de 8 anos no mercado garante que você tenha 
            o melhor custo-benefício e performance no seu investimento.
          </p>
        </div>

        {/* Advantages Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {advantages.map((advantage, index) => {
            const Icon = iconMap[advantage.icon];
            return (
              <Card 
                key={index} 
                className="group hover:shadow-xl transition-all duration-300 border-2 hover:border-orange-200 h-full"
              >
                <CardContent className="p-8 text-center space-y-4">
                  <div className="w-16 h-16 bg-gradient-to-br from-orange-100 to-orange-50 rounded-2xl flex items-center justify-center mx-auto group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-8 h-8 text-orange-600" />
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-900">
                    {advantage.title}
                  </h3>
                  
                  <p className="text-gray-600 leading-relaxed">
                    {advantage.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Stats Section */}
        <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-3xl p-8 md:p-12 text-white">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl md:text-5xl font-bold text-green-400 mb-2">500+</div>
              <div className="text-gray-300">Computadores Montados</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-blue-400 mb-2">98%</div>
              <div className="text-gray-300">Taxa de Satisfação</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-purple-400 mb-2">R$ 800</div>
              <div className="text-gray-300">Economia Média</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-orange-400 mb-2">8+</div>
              <div className="text-gray-300">Anos de Experiência</div>
            </div>
          </div>
          
          <div className="text-center mt-8 pt-8 border-t border-gray-700">
            <h3 className="text-2xl font-bold mb-4">
              Conhecimento que Faz a Diferença
            </h3>
            <p className="text-lg text-gray-300 max-w-2xl mx-auto">
              Sabemos onde encontrar as melhores ofertas, quais peças são realmente compatíveis 
              e como extrair o máximo de performance do seu investimento.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Advantages;